import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injectable, Injector, Input, OnChanges, ViewEncapsulation, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { LongCode } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { map, Observable, of } from 'rxjs';
import * as Enumerable from 'linq';

@Component({
  selector: 'sms-longcode-picker',
  templateUrl: './sms.longcode.picker.component.html',
  styleUrls: ['./sms.longcode.picker.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule
  ],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SmsLongCodePickerComponent), multi: true }
  ],
})
export class SmsLongCodePickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: LongCode[];
  @Input() public placeholder = '<SMS Long Code>';
  @Input() public appendTo: any;
  @Input() public multiple: boolean;
  @Input() public clearable: boolean;

  public data$: Observable<LongCode[]>;
  public PickerItemStyle = PickerItemStyle;

  constructor(
    injector: Injector,
    private longCodes: SmsLongCodePickerService
  ) {
    super(injector);
    this.fetch = PickerFetch.Automatic;
  }

  public ngOnChanges() {

    this.data$ = this.fetch === PickerFetch.Automatic
      ? this.longCodes.getLongCodes()
      : of(this.data);

  }

}


@Injectable({ providedIn: 'root' })
export class SmsLongCodePickerService {

  constructor(
    private http: HttpClient
  ) { }

  public getLongCodes(): Observable<LongCode[]> {
    return this.http.get<LongCode[]>(`/api/picker/sms`)
      .pipe(
        map(x => {
          return Enumerable
            .from(x)
            .orderBy(x => x.name)
            .toArray();
        })
      );
  }

}

